module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAAAmCAYAAAB0xJ2ZAAAABHNCSVQICAgIfAhkiAAAAAlwSFlzAAAN1wAADdcBQiibeAAAABl0RVh0U29mdHdhcmUAd3d3Lmlua3NjYXBlLm9yZ5vuPBoAAAB6SURBVGiB7ddBEQJBEMDAHQrMIQ1xpwATGABk9GMSBan8MjPzO4u5aQFNAbSApgBaQFMALaApgBbQFEALaO7P2d1g3uc0Q5spgBbQFEALaAqgBTQF0AKaAmgBzXxej9UvMN+rGVpNAbSApgBaQFMALaApgBbQFEALaP7cDgi/zXcXlwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/scenes/components/Header/components/LanguageSelect/de.png
// module id = 476
// module chunks = 0